

// must be 4
export const recents = [
    {
        "titre": "« Le tunnel du bonheur »",
        "taille": "90/90 cm",
        "prix": "350€",
        "description": "Un tableau sur toile fait de plâtre à la colle et de tissu traditionnel bôgôlan (Afrique de l’Ouest)",
        "image": "assets/images/1.png"
    },
    {
        "titre": "« Le pont du bonheur »",
        "taille": "90/90 cm",
        "prix": "350€",
        "description": "Un tableau sur toile fait d’enduit à la colle et de tissu traditionnel bôgôlan (Afrique de l’Ouest)",
        "image": "assets/images/2.png"
    },
    {
        "titre": "« Le Progrès au Kôkô donda »",
        "taille": "100/70 cm",
        "prix": "250€",
        "description": "Tableau sur toile, fait d’enduit à la colle, de tissu bôgôlan, du fil",
        "image": "assets/images/3.png"
    },
    {
        "titre": "« L'oeil du danfani »",
        "taille": "80/60 cm",
        "prix": "210€",
        "description": "Tableau sur toile, peinture, enduit, tissu faso danfani, colle",
        "image": "assets/images/4.png"
    },
    {
        "titre": "« L'Autoroute du faso danfani »",
        "taille": "80/60 cm",
        "prix": "210€",
        "description": "Tableau sur toile, peinture, enduit, tissu faso danfani, colle",
        "image": "assets/images/5.png"
    },{
        "titre": "« Disque de kôko donda »",
        "taille": "80/60 cm",
        "prix": "240€",
        "description": "Matières : peinture, enduit, Lèfê artisanal, tissu kôko donda",
        "image": "assets/images/6.png"
    },
    {
        "titre": "« Feuille Kôkô donda »",
        "taille": "80/60 cm",
        "prix": "250€",
        "description": "Matières : enduit, tissu kôkô don da, ",
        "image": "assets/images/7.jpg"
    },
    {
        "titre": "« Faso danfani aux coris »",
        "taille": "50/40 cm",
        "prix": "70€",
        "description": "Matières : peinture, enduit, tissu faso danfani, coris",
        "image": "assets/images/8.png"
    },{
        "titre": "« Rond point du faso danfani »",
        "taille": "80/60 cm",
        "prix": "240€",
        "description": "Matières : Toile, enduit, bombes, fil, tissu batik imagé, colle",
        "image": "assets/images/9.png"
    },{
        "titre": "« Femme battante »",
        "taille": "80/60 cm",
        "prix": "210€",
        "description": "Matières : peinture, enduit, tissu batik imagé",
        "image": "assets/images/10.png"
    },{
        "titre": "« Disque Lêfê »",
        "taille": "50/40 cm",
        "prix": "180€",
        "description": "Matières : peinture, enduit, Lêfê, coris",
        "image": "assets/images/11.png"
    },{
        "titre": "« Disque Lêfê »",
        "taille": "50/40 cm",
        "prix": "180€",
        "description": "Matières : peinture, enduit, Lêfê, coris",
        "image": "assets/images/12.png"
    },{
        "titre": "« Disque Lêfê »",
        "taille": "50/40 cm",
        "prix": "180€",
        "description": "Matières : peinture, enduit, Lêfê, coris",
        "image": "assets/images/13.png"
    },{
        "titre": "« Rives d'orées du faso danfani »",
        "taille": "50/40 cm",
        "prix": "80€",
        "description": "Matières : Peinture, enduit, tissu faso danfani",
        "image": "assets/images/14.png"
    },
    {
        "titre": "« Tâche quotidienne »",
        "taille": "80/60 cm",
        "prix": "210€",
        "description": "Matières : Peinture, enduit, tissu batik imagé",
        "image": "assets/images/15.png"
    },
    {
        "titre": "« Les anges de l’amour »",
        "taille": "80/60 cm",
        "prix": "210€",
        "description": "Matières : Peinture, enduit, tissu batik imagé",
        "image": "assets/images/16.png"
    },
    {
        "titre": "« Le carré des coris »",
        "taille": "120/40cm",
        "prix": "220€",
        "description": "Tableau sur toile fait de peinture, plâtre, tissu, coris",
        "image": "assets/images/17.png"
    },
    {
        "titre": "« Les ruisseaux du bonheur »",
        "taille": "120/40cm",
        "prix": "220€",
        "description": "Tableau sur toile fait de peinture, enduit, tissu, fils",
        "image": "assets/images/18.png"
    },
    {
        "titre": "« Les espoirs »",
        "taille": "120/40cm",
        "prix": "220€",
        "description": "Tableau sur toile fait de peinture, enduit, tissu bogolan a coton",
        "image": "assets/images/19.png"
    },
    {
        "titre": "« Les symboles du royaume »",
        "taille": "120/40cm",
        "prix": "220€",
        "description": "Tableau sur toile fait de peinture, enduit, tissu royal aux coris",
        "image": "assets/images/20.png"
    },
    {
        "titre": "« Coeur blanc au Bôgôlan »",
        "taille": "70/50 cm",
        "prix": "190€",
        "description": "Matières : Tableau sur du bois, vitrée, enduit, tissu bôgôlan",
        "image": "assets/images/21.jpg"
    },
    {
        "titre": "« Corps de femme »",
        "taille": "80/60 cm",
        "prix": "230€",
        "description": "Matières : Tableau sur toile, peinture, enduit, tissu bôgôlan »",
        "image": "assets/images/22.jpg"
    },
    {
        "titre": "« L'amour vrai »",
        "taille": "70/60 cm",
        "prix": "190€",
        "description": "Matières : Tableau sur enduit et batik, peinture »",
        "image": "assets/images/23.png"
    },
    {
        "titre": "« L'univers' »",
        "taille": "30/30 cm",
        "prix": "40€",
        "description": "Tableau multicolore fait sur toile.",
        "image": "assets/images/24.jpg"
    },
    {
        "titre": "« Le coeur en bôgôlan »",
        "taille": "30/30 cm",
        "prix": "30€ l'unité",
        "description": "Tableau fait sur toile, peinture, tissu bôgôlan, coris",
        "image": "assets/images/26.png"
    },
    {
        "titre": "« Le coeur en faso danfani »",
        "taille": "30/30 cm",
        "prix": "30€",
        "description": "Tableau fait sur toile, peinture, faso danfani, coris",
        "image": "assets/images/25.png"
    }
];

